import { Component, inject } from '@angular/core';
import { BillPayServicesService } from '../helper/bill-pay-services.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FetchBillValidateComponent } from '../fetch-bill-validate/fetch-bill-validate.component';
import { ToasterService } from '@core/services/toaster.service';
import { ValidatePipe } from '../helper/validate.pipe';
import { GetTitleService } from '@core/services/get-title.service';
import { ConfirmationComponent } from '@core/customCDK/cdkCustomMdl/components/confirmation/confirmation.component';
import {
  ConfirmationModalConfig,
  ConfirmationModalService,
} from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { ConfirmationModalOverlayRef } from '@core/customCDK/cdkCustomMdl/classes/confirmation-modal.ref';

@Component({
  selector: 'app-fetch-bill',
  standalone: true,

  imports: [CommonModule, FormsModule, ReactiveFormsModule],

  templateUrl: './fetch-bill.component.html',
  styleUrl: './fetch-bill.component.scss',
})
export class FetchBillComponent {
  _BillPayService: BillPayServicesService = inject(BillPayServicesService);
  _ConfirmationModalService: ConfirmationModalService = inject(
    ConfirmationModalService
  );
  params_form: FormGroup = new FormGroup({});
  dataList: any;
  detailsList: any;
  type: string = 'number';

  constructor(
    private fb: FormBuilder,
    private route: Router,
    private toaster: ToasterService,
    private _GetTitleService: GetTitleService,
    public dialogRef: ConfirmationModalService
  ) {
    // this.params_form = this.fb.group({});
  }

  ngOnInit() {
    // console.log('functioncalled...')
    this.getBillDetailse();
    // this.formInit()
  }
  formInit() {
    let formControls: any = {};

    this.dataList.forEach((el: any) => {
      const validations = [];

      // Required validation
      if (el.is_required == '1') {
        validations.push(Validators.required);
      }

      // Min Length validation
      if (el.min_length) {
        validations.push(Validators.minLength(+el.min_length));
      }

      // Max Length validation
      if (el.max_length) {
        validations.push(Validators.maxLength(+el.max_length));
      }

      // Regex pattern validation
      if (el.regex) {
        validations.push(Validators.pattern(el.regex));
      }

      // Assign the control with validations
      formControls[el.param_name] = ['', validations];
      this.params_form.addControl(
        el.param_code,
        this.fb.control('', validations)
      );
      this.params_form.updateValueAndValidity();
    });
  }

  getBillDetailse() {
    this._BillPayService.getFetchBillData().subscribe((res: any) => {
      // console.log(res , 'response..');
      if (res) {
        this._GetTitleService.title = res?.biller_name;
        this.dataList = res?.bill_params;
        this.detailsList = res;
        this.formInit(); // Initialize form after data is fetched
        // this.toaster.showSuccess(res?.message , 'success')
      } else {
        this.route.navigate(['/bbps']);
        // this.toaster.showError(res?.message , 'error')
      }
    });
  }
  submit() {
    const value = this.params_form?.value;

    // console.log(value, 'value...')
    const biller_params: any = {};
    const inputParams: any = { input: [] };
    this.dataList.forEach((el: any) => {
      // console.log(el, 'el...')
      // biller_params[el?.param_code] = value[el?.param_code];
      inputParams.input.push({
        paramName: el?.param_name,
        paramValue: value[el?.param_code],
      });
    });
    this._BillPayService._BillParams.next(inputParams);
    const payLoad = {
      // category_code : this.detailsList?.category_code,
      biller_id: this.detailsList?.biller_id,
      inputParams: inputParams,
    };
    this._BillPayService.getValidates(payLoad).subscribe((res: any) => {
      if (res.responsecode == '1') {
        // console.log(res , 'response ..... form fetchbill component...')
        let data = res;
        this._BillPayService._ValidateUserData.next(data);

        // this.cancel();

        // this.toaster.showSuccess(res?.message , 'success')

        this._ConfirmationModalService.init(FetchBillValidateComponent);
      } else {
        // this.toaster.showError(res?.message , 'error');
        const customConfig: ConfirmationModalConfig = {
          data: {
            icon: 'error',
            msg: res?.message,
            // btnConfirm: 'Okay',
            btnClose: 'Okay',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
          },
        };
        this._ConfirmationModalService
          .init(ConfirmationComponent, customConfig)
          .subscribe((events: any) => {
            events.initRef.close();
          });
      }
    });
  }
  cancel() {
    // console.log(this._ConfirmationModalService.dialogRef);
    // if (this._ConfirmationModalService.dialogRef) {
    //   this._ConfirmationModalService.dialogRef.close();
    // }
    // this.dialogRef.close();
  }
  ngOnDestroy() {}
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  }
}
